export enum SharedButtonType {
  Primary = 'primary',
  Secondary = 'secondary',
  Outline = 'outline',
  TextLink = 'textlink',
  Link = 'link',
}
